import Loadable from 'react-loadable';
import React from 'react';
import Skeleton from '../primitives/skeleton';
import type { AtlassianSwitcherProps } from '../../types';
import type { GenericSwitcherProps } from './generic-switcher';

export const loadAtlassianSwitcher = (): Promise<(props: AtlassianSwitcherProps) => JSX.Element> =>
	import(
		/* webpackChunkName: "@ak-switcher-chunk-atlassian-switcher" */ './atlassian-switcher'
	).then((module) => module.default);

export const loadGenericSwitcher = (): Promise<
	(props: GenericSwitcherProps) => React.JSX.Element
> =>
	import(/* webpackChunkName: "@ak-switcher-chunk-generic-switcher" */ './generic-switcher').then(
		(module) => module.default,
	);

export const AtlassianSwitcherLoader: React.ComponentType<AtlassianSwitcherProps> &
	Loadable.LoadableComponent = Loadable({
	loader: loadAtlassianSwitcher,
	loading: () => <Skeleton />,
});

export const GenericSwitcherLoader: React.ComponentType<GenericSwitcherProps> &
	Loadable.LoadableComponent = Loadable({
	loader: loadGenericSwitcher,
	loading: () => <Skeleton />,
});
